import React from 'react';
import styled from 'styled-components';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { observer } from 'mobx-react-lite';

import { BaseBlock } from '../../schedule/components/styled-strips';
import Styles from '../stripboard.module.scss';
import { StripProps } from './stripboard-table';

export type DayBreakStripProps = StripProps & {
  centerText: string;
  endText: React.ReactNode;
};

const DayBreakStripComponent: React.FC<DayBreakStripProps> = observer(
  ({ row, dayId, centerText, endText }) => {
    const strip = row.original;

    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
      id: strip._id,
      data: {
        dayId,
        type: 'row',
        row: strip,
      },
      disabled: true,
      animateLayoutChanges: () => true,
      transition: {
        duration: 150,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
      },
    });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
    };

    return (
      <div
        className={Styles.stickyStrip}
        data-direction="bottom"
        style={style}
        ref={setNodeRef}
        {...attributes}
        {...listeners}
      >
        <div className={Styles.stickyStripContent}>
          <div />

          <CenterWrapper>
            <EndOfDay>
              <DayText>{centerText}</DayText>
            </EndOfDay>
          </CenterWrapper>

          {endText}
        </div>
      </div>
    );
  },
);

export const DayBreakStrip = React.memo(DayBreakStripComponent);

const CenterWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 1.6rem;
  justify-content: space-between;
  width: 100%;
`;

const DayText = styled.p`
  color: var(--color-texts-high-contrast);
  line-height: 1.8rem;
`;

const EndOfDay = styled(BaseBlock)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 400;
  font-size: 1.4rem;
  padding: 0.8rem;
`;
